import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ERROR_MESSAGE } from "../../constants/error_message";
import { TRANSLATE } from "../../i18n/translation";

type CustomError = {
  messageKey?: string;
};

const CustomErrorMessage = (error: CustomError) => {
  const { messageKey } = error;
  const { t } = useTranslation();

  switch (messageKey) {
    case ERROR_MESSAGE.WRONG_CREDENTIAL:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.WRONG_CREDENTIAL)}
        </span>
      );
    case ERROR_MESSAGE.REQUIRED_USERNAME:
      return (
        <span className="text-danger">{t(TRANSLATE.REQURED_USERNAME)}</span>
      );
    case ERROR_MESSAGE.REQUIRED_PASSWORD:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.REQURED_PASSWORD)}
        </span>
      );
    case ERROR_MESSAGE.REQUIRED_PASSWORD_CONFIRM:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.CONFIRM_PASSWORD)}
        </span>
      );
    case ERROR_MESSAGE.PASSWORD_NOT_MATCH:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.PASSWORD_NOT_MATCH)}
        </span>
      );
    case ERROR_MESSAGE.REQUIRED_AMOUNT:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.ENTER_BUY_AMOUNT)}
        </span>
      );
    case ERROR_MESSAGE.INSUFFICIENT:
      return (
        <span className="text-danger error">{t(TRANSLATE.INSUFFICIENT)}</span>
      );
    case ERROR_MESSAGE.REQUIRED_ACCOUNT_NAME:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.ENTER_ACCOUNT_NAME)}
        </span>
      );
    case ERROR_MESSAGE.REQUIRED_ACCOUNT_NO:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.ENTER_ACCOUNT_NO)}
        </span>
      );
    case ERROR_MESSAGE.REQUIRED_BANK_NAME:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.ENTER_BANK_NAME)}
        </span>
      );
    case ERROR_MESSAGE.REQUIRED_OPTIONS:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.REQUIRED_OPTIONS)}
        </span>
      );
    case ERROR_MESSAGE.OLD_PASSWORD_INCORRECT:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.OLD_PASSWORD_INCORRECT)}
        </span>
      );
    case ERROR_MESSAGE.REQUIRED_OLD_PASSWORD:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.PLEASE_OLD_PASSWORD)}
        </span>
      );
    case ERROR_MESSAGE.REQUIRED_NEW_PASSWORD:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.PLEASE_NEW_PASSWORD)}
        </span>
      );
    case ERROR_MESSAGE.MAX:
      return (
        <span className="text-danger error">{t(TRANSLATE.MAX_AMOUNT)}</span>
      );
    case ERROR_MESSAGE.INVALID_OTP_CODE:
      return <span className="text-danger error">{t("invalidOtpCode")}</span>;
    case ERROR_MESSAGE.TRADE_MINIMUM_BALANCE:
      return (
        <span className="text-danger error">{t("tradeMinimumBalance")}</span>
      );
    default:
      return (
        <span className="text-danger error">
          {t(TRANSLATE.SOMETHING_WENT_WRONG)}
        </span>
      );
  }
};

CustomErrorMessage.propTypes = {
  messageKey: PropTypes.string.isRequired,
};

const CustomSuccessMessage = (error: CustomError) => {
  const { messageKey } = error;
  const { t } = useTranslation();

  switch (messageKey) {
    case "registerSuccessText":
      return <span className="text-success">{t("registerSuccessText")}</span>;
    case "loginSuccessText":
      return <span className="text-success">{t("loginSuccessText")}</span>;
    case "withdrawSuccessTitle":
      return <span className="text-success">{t("withdrawSuccessTitle")}</span>;
    default:
      return <span className="text-success">{t(TRANSLATE.SUCCESS)}</span>;
  }
};
CustomSuccessMessage.propTypes = {
  messageKey: PropTypes.string,
};

export default CustomErrorMessage;

export const showErrorToast = (messageKey: string) => {
  toast.error(<CustomErrorMessage messageKey={messageKey} />);
};

export const showSuccessToast = (messageKey?: string | undefined) => {
  toast.success(<CustomSuccessMessage messageKey={messageKey} />);
};
